import { Trustbar as SharedTrustbar } from '@selina-finance/ui';
import { useTranslation } from 'react-i18next';

interface TrustbarProps {
    className?: string;
}

const Trustbar = ({ className }: TrustbarProps) => {
    const { t } = useTranslation();

    return (
        <SharedTrustbar
            className={className}
            message={t('trustbar.message')}
            widgetClassName='lg:-mr-[40px]'
        />
    );
};

export default Trustbar;
